var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('a',{attrs:{"href":_vm.outLink,"target":"_blank","rel":"nofollow"}},[_vm._v("\n    "+_vm._s(_vm.text)+" "),(!_vm.disableIcon)?_c('i',{staticClass:"bi bi-chevron-double-right ms-2"}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }